import { Account_Read_Typeahead } from '@treadinc/horizon-api-spec';

import { FilterMenuOption } from '~components/Filters/FilterMenuItem';
import { AccountTypeahead } from '~hooks/useAccount/models';
import {
  ActingCompany,
  connectedVendorCompanyOption,
  withOwnCompanyFirst,
} from '~utils/vendorCompanyOptions';

/**
 * Builds the option list for the "Equipment owner" grid filter: the viewer's own company (for
 * internally owned trucks) plus every connected vendor, keyed by the vendor's *company* id rather
 * than its account id, because the server resolves a truck's owner to a company. This mirrors the
 * equipment dialog's Owned by picker, minus its empty-string sentinel for the acting company, which
 * would not survive a string[] query param or a chip lookup.
 */
export function buildEquipmentOwnerOptions(
  accounts: Account_Read_Typeahead[],
  actingCompany: ActingCompany,
  searchQuery: string,
  isFirstPage: boolean,
): FilterMenuOption[] {
  const vendorOptions = accounts.flatMap(
    (account) => connectedVendorCompanyOption(AccountTypeahead.parse(account)) ?? [],
  );

  const ownCompanyOption =
    isFirstPage && actingCompany.id
      ? { label: actingCompany.name, value: actingCompany.id }
      : undefined;

  return withOwnCompanyFirst(vendorOptions, ownCompanyOption, searchQuery);
}
